import { useFragmentsViewCapture } from '@app/modules/fragments/hooks/useFragmentsViewCapture';
import { downloadFile } from '@mi-front/core';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import { Button, Tooltip } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const downloadAudioMp3Message = defineMessage({
  id: 'fragments.export.downloadAudioMp3',
  defaultMessage: 'Descargar audio (mp3)',
});

const audioMp3GeneratingTooltipMessage = defineMessage({
  id: 'fragments.export.audioMp3GeneratingTooltip',
  defaultMessage: 'Generación de MP3 en proceso',
});

interface Props {
  /** Signed URL for the encoded MP3 alternate asset; absent while encoding or not yet available. */
  readonly audioMp3Url: string | undefined;
}

/**
 * Download control for the MP3 alternate audio on video fragments.
 * Renders a normal download when the URL exists; otherwise a disabled button with an explanatory tooltip.
 */
export function DownloadFragmentVideoAudioMp3Btn({ audioMp3Url }: Props) {
  const { formatMessage } = useIntl();
  const { downloadMedia } = useFragmentsViewCapture();

  function handleClick() {
    if (!audioMp3Url) {
      return;
    }
    downloadMedia({ mediaType: 'AUDIO' });
    downloadFile(audioMp3Url, false);
  }

  if (audioMp3Url) {
    return (
      <Button
        color="secondary"
        variant="outlined"
        size="small"
        onClick={handleClick}
        startIcon={<AudioFileIcon />}
      >
        {formatMessage(downloadAudioMp3Message)}
      </Button>
    );
  }

  return (
    <Tooltip title={formatMessage(audioMp3GeneratingTooltipMessage)}>
      <span>
        <Button
          color="secondary"
          variant="outlined"
          size="small"
          disabled
          startIcon={<AudioFileIcon />}
        >
          {formatMessage(downloadAudioMp3Message)}
        </Button>
      </span>
    </Tooltip>
  );
}
